import React, { useState } from "react";
import {
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell,
    Button,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    CircularProgress,
    Tooltip,
    Menu,
    MenuItem,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles"; // Import makeStyles for custom styles
import EditDataForm from "./EditDataForm";


const useStyles = makeStyles((theme) => ({
    headerCell: {
        fontWeight: "bold",
        backgroundColor: "#152F8F", // Set header background color
        color: "white", // Set header text color
        border: "1px solid #ddd", // Add border to header cells
    },
    header: {
        position: "sticky",
        top: 0,
        backgroundColor: "#152F8F",
        color: "white",
        zIndex: 1000, // Ensures header stays above body content
    },
    tableBodyWrapper: {
        maxHeight: "calc(100vh - 200px)", // Adjust based on header height
        overflowY: "auto", // Allows vertical scrolling of table body
        position: "relative",
        "&::-webkit-scrollbar": {
            width: "0px", // Hides scrollbar
            background: "transparent",
        },
    },
    table: {
        border: "1px solid #ddd",
        minWidth: "1000px",

    },
    tableContainer: {
        position: "relative", // Ensures relative positioning
        width: "100%",
        height: "calc(100vh - 150px)", // Adjust height to fit within the viewport
        display: "flex",
        flexDirection: "column",
    },

    tableWrapper: {
        marginBottom: theme.spacing(2),
        flexGrow: 1, // Makes it expand within the container
        overflowX: "auto", // Allows horizontal scrolling
        overflowY: "auto", // Allows vertical scrolling
        position: "relative", // Ensures proper positioning
    },
    responsiveTable: {
        width: "100%",
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.875rem", // Adjust font size for smaller screens
        },
    },
    responsiveCell: {
        border: "1px solid #ddd",
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.75rem", // Adjust cell font size for smaller screens
            padding: "4px", // Reduce padding for smaller screens
        },
    },
    responsiveButton: {
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.7rem", // Adjust button font size
            padding: "5px 8px", // Adjust button padding
        },
    },
    scrollbarContainer: {
        position: "fixed", // Fixes the scrollbar at the bottom
        bottom: 0, // Keeps it at the bottom of the screen
        left: 0,
        width: "100%",
        backgroundColor: "#fff", // Optional: background color for visibility
        borderTop: "1px solid #ddd",
        padding: "5px 0",
        zIndex: 1000, // Ensures it stays above other elements
    },
    scrollbar: {
        width: "100%",
        overflowX: "scroll",
    },
}));

const TableComponent = ({
    data,
    mappedData,
    handleDelete,
    handleEdit,
    loading,
    currentPage,
    itemsPerPage, 
    api
}) => {
    
    const classes = useStyles();

    const [isEditDialogOpen, setEditDialogOpen] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [rowToDelete, setRowToDelete] = useState(null);

    const isRowHighlighted = (row) => {
        return mappedData.some(mappedRow =>

            mappedRow.small_town_name === row.municipality
        );
    };

    // Open the Edit dialog with selected row data
    const handleEditClick = (rowData) => {
      

        setSelectedRowData(rowData);

        setEditDialogOpen(true); // Open the dialog
    };


    // Handle close action of the Edit dialog
    const handleEditClose = () => {
        setEditDialogOpen(false);
        setSelectedRowData(null);
    };

    // Submit action for Edit form
    const handleEditSubmit = (updatedData) => {
        handleEdit(updatedData); // Pass updated data back to parent component
        handleEditClose(); // Close the dialog

    };

    // Open the Delete Confirmation Dialog
    const handleDeleteClick = (row) => {
        setRowToDelete(row);
        setDeleteDialogOpen(true);
    };

    // Close the Delete Confirmation Dialog
    const handleDeleteClose = () => {
        setDeleteDialogOpen(false);
        setRowToDelete(null);
    };

    // Confirm Delete Action
    const confirmDelete = () => {

        handleDelete(rowToDelete); // Trigger the delete function with selected row ID

        handleDeleteClose(); // Close the dialog
    };


    
    return (
        <>
            <div className={classes.tableContainer}>
                <div className={classes.tableWrapper}>

                    <Table className={`${classes.table} ${classes.responsiveTable}`}>
                        <TableHead className={classes.header}>
                            <TableRow>
                                <TableCell className={classes.headerCell} style={{ width: '50px', minWidth: '50px' }}>S.No.</TableCell>
                                <TableCell className={classes.headerCell}

                                    style={{

                                        width: '200px',

                                        maxWidth: '200px',

                                        minWidth: '200px',

                                        overflow: 'hidden',

                                        textOverflow: 'ellipsis',

                                        whiteSpace: 'nowrap',

                                    }}>Town Details</TableCell>
                                <TableCell

                                    className={classes.headerCell}
                                    style={{ width: 'auto' }}
                                >

                                   Town Url
                                </TableCell>




                                <TableCell className={classes.headerCell} style={{ width: '150px', minWidth: '150px' }}>Town Notes</TableCell>
                                <TableCell className={classes.headerCell}
                                    style={{ width: 'auto' }}
                                >BoE Url</TableCell>
                                <TableCell className={classes.headerCell} style={{ width: '150px', minWidth: '150px' }}>BoE Notes</TableCell>
                                <TableCell className={classes.headerCell} style={{ width: '150px', minWidth: '150px' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>



                        <TableBody className={classes.table}>

                            {data.map((row, index) => {
                                return (
                                    <TableRow>

                                        <TableCell>{(currentPage - 1) * itemsPerPage + index + 1}.</TableCell>

                                        <TableCell className={classes.responsiveCell}>
                                            <div>
                                                <div><strong>Country:</strong> {row?.country || 'N/A'}</div>
                                                <div><strong>State:</strong> {row?.state || 'N/A'}</div>
                                                <div><strong>County:</strong> {row?.county || 'N/A'}</div>
                                                <div><strong>Town:</strong> <span style={isRowHighlighted(row) ? { fontWeight: 'bold', color: 'green' } : {}}>{row?.municipality || 'N/A'}</span></div>
                                            </div>
                                        </TableCell>

                                        {/* TOWN CHANNEL URLs */}
                                        <TableCell
                                            className={classes.responsiveCell}
                                            style={{
                                                wordBreak: 'break-word', // ✅ let long URLs wrap instead of overflow
                                                whiteSpace: 'normal',
                                            }}
                                        >
                                            {row?.town?.channels?.length > 0 ? (
                                                <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                                    {row?.town?.channels
                                                        .filter(channel => channel?.town_url && channel?.town_url !== "")
                                                        .map((channel, idx) => {
                                                            const fullUrl = channel?.town_url;
                                                            const shortUrl = fullUrl.replace(/^(https?:\/\/)?(www\.)?youtube\.com\//, '');

                                                            return (
                                                                <li key={idx}>
                                                                    {fullUrl === 'none' || fullUrl === 'None' ? (
                                                                        fullUrl
                                                                    ) : (
                                                                        <Tooltip title={fullUrl} arrow>
                                                                            <a
                                                                                href={fullUrl}
                                                                                style={{
                                                                                    textDecoration: "none",
                                                                                    display: "block",
                                                                                    width: "100%",
                                                                                    wordBreak: "break-all", // ✅ make long URLs break nicely
                                                                                }}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                {shortUrl}
                                                                            </a>
                                                                        </Tooltip>
                                                                    )}
                                                                </li>
                                                            );
                                                        })}
                                                </ul>
                                            ) : (
                                                "N/A"
                                            )}
                                        </TableCell>



                                        {/* TOWN NOTES */}
                                        <TableCell className={classes.responsiveCell}>
                                            <Tooltip title={row?.town?.notes || ''} arrow>
                                                <span>
                                                    {row?.town?.notes?.substring(0, 4) || ''}
                                                </span>
                                            </Tooltip>
                                        </TableCell>

                                        {/* BOE CHANNEL URLs */}
                                        <TableCell
                                            className={classes.responsiveCell}
                                            style={{
                                                wordBreak: 'break-word', // ✅ let long URLs wrap instead of overflow
                                                whiteSpace: 'normal',
                                            }}
                                        >
                                            {row?.boe?.channels?.length > 0 ? (
                                                <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                                    {row?.boe?.channels
                                                        .filter(channel => channel?.boe_url && channel?.boe_url !== "")
                                                        .map((channel, idx) => {
                                                            const fullUrl = channel?.boe_url;
                                                            const shortUrl = fullUrl.replace(/^(https?:\/\/)?(www\.)?youtube\.com\//, '');

                                                            return (
                                                                <li key={idx}>
                                                                    {fullUrl === 'none' || fullUrl === 'None' ? (
                                                                        fullUrl
                                                                    ) : (
                                                                        <Tooltip title={fullUrl} arrow>
                                                                            <a
                                                                                href={fullUrl}
                                                                                style={{
                                                                                    textDecoration: "none",
                                                                                    display: "block",
                                                                                    width: "100%",
                                                                                    wordBreak: "break-all", // ✅ make long URLs break nicely
                                                                                }}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                {shortUrl}
                                                                            </a>
                                                                        </Tooltip>
                                                                    )}
                                                                </li>
                                                            );
                                                        })}
                                                </ul>
                                            ) : (
                                                "N/A"
                                            )}
                                        </TableCell>


                                        {/* BOE NOTES */}
                                        <TableCell className={classes.responsiveCell}>
                                            <Tooltip title={row?.boe?.notes || ''} arrow>
                                                <span>
                                                    {row?.boe?.notes?.substring(0, 4) || ''}
                                                </span>
                                            </Tooltip>
                                        </TableCell>

                                        <TableCell className={classes.responsiveCell}>
                                            <Box display={"flex"} flexDirection={"column"} width="100%">
                                                <Box display="flex" flexDirection="column" width="60%" alignItems={"center"} justifyContent={"center"} margin={"auto"}>
                                                    <Button
                                                        variant="contained"
                                                        className={classes.responsiveButton}
                                                        style={{

                                                            marginBottom: "10px",
                                                            backgroundColor: "#0B194A",
                                                            color: "white",

                                                        }}
                                                        onClick={() => handleEditClick(row)} // Open Edit dialog
                                                    >
                                                        <i style={{ fontSize: "20px" }} className="fa-solid fa-pen-to-square"></i>
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        className={classes.responsiveButton}
                                                        style={{ backgroundColor: "red" }}
                                                        onClick={() => handleDeleteClick(row)} // Pass the row data here
                                                    >
                                                        <span className="material-symbols-outlined">delete</span>
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>

                    </Table>

                </div>
            </div>

            {/* Edit Dialog */}
            {selectedRowData && (
                <EditDataForm
                    maxWidth="md"
                    open={isEditDialogOpen}
                    // onDeleteClose={handleDeleteClose}
                    onSubmit={handleEditSubmit}
                    editData={selectedRowData}
                    onClose={handleEditClose} // Pass the selected row data to Edit form
                    api={api}
                />
            )}

            {/* Delete Confirmation Dialog */}
            <Dialog
                maxWidth="sm"
                open={isDeleteDialogOpen}
                onClose={handleDeleteClose}
                aria-labelledby="delete-confirmation-dialog"
            >
                <DialogTitle id="delete-confirmation-dialog">
                    Confirm Deletion
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        This will only delete the data from the from this table.
                    </DialogContentText>
                    <DialogContentText sx={{ display: "block", marginTop: 1 }}>
                        If you have deleted it once, you cannot add it again.
                    </DialogContentText>
                    <DialogContentText sx={{ marginTop: 1 }}>
                        Are you sure you want to delete this entry? This action cannot be
                        undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteClose} color="primary" autoFocus>
                        Cancel
                    </Button>
                    <Button onClick={confirmDelete} color="secondary">
                        Yes, Delete
                    </Button>
                </DialogActions>
            </Dialog>


        </>
    );
};

export default TableComponent;
